.RtrCBHideLaptop
    @media #{$laptop}
        display: none !important
.RtrCBHideBelowLaptop
    @media not all and #{$laptop}
        display: none !important

